import {
  BottonLoader,
  PrimaryButton,
} from "components/button/button.component";
import { alertMessage } from "components/toolkit/initial-state.component";
import { ChangeEvent, FormEvent, useState } from "react";
import { useSelector } from "react-redux";
import { selectInfo } from "store/data/data.selector";
import { isValidEmail } from "utils/helper/helper";
import { hostURL } from "utils/helper/states";

const defaultValues = {
  fullname: "",
  email: "",
  message: "",
};
function ContactForm() {
  const [formData, setFormData] = useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const { fullname, email, message } = formData;

  const appUtil = useSelector(selectInfo);

  const resetForm = () => {
    setFormData(defaultValues);
  };
  const handleOpenGmail = () => {
    const email = appUtil?.email;
    const subject = "CONTACT US";
    const body = `${formData.message}\n\nFrom ${formData.fullname}`;

    const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailURL, "_blank");
    resetForm();
  };

  // const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
  //   setLoading(true);
  //   try {
  //     event.preventDefault();
  //     const result = await fetch(`${hostURL}/api/auth/user/login`, {
  //         method: "POST",
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(formData),
  //       }),
  //       res = await result.json();
  //     if (res.success) {
  //       resetForm();
  //       alertMessage("success", res.message);
  //     } else {
  //       alertMessage("warn", res.message);
  //     }
  //   } catch (error) {
  //     const err = error as Error;
  //     console.log(error as Error);
  //     alertMessage("error", err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormData((state) => ({ ...state, [name]: value }));
  };
  const handleTextAreaChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    setFormData((state) => ({ ...state, [name]: value }));
  };
  const isFormReady =
    isValidEmail(email) && fullname.length > 0 && message.length > 0;
  return (
    <form onSubmit={handleOpenGmail} className="space-y-3">
      <input
        type="text"
        placeholder="Full Name"
        name="fullname"
        value={fullname}
        onChange={handleChange}
        className="input input-bordered w-full"
      />
      <input
        type="email"
        placeholder="Email address"
        name="email"
        value={email}
        onChange={handleChange}
        className="input input-bordered w-full"
      />
      <textarea
        className="textarea textarea-bordered w-full"
        placeholder="Leave a message"
        name="message"
        onChange={handleTextAreaChange}
        defaultValue={message}
      ></textarea>

      {loading ? (
        <BottonLoader />
      ) : (
        <PrimaryButton disabled={!isFormReady}>Send</PrimaryButton>
      )}
    </form>
  );
}

export default ContactForm;
